/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage100 = createReactComponent("outline", "percentage-100", "IconPercentage100", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "fill": "currentColor", "key": "svg-0" }]]);

export { IconPercentage100 as default };
//# sourceMappingURL=IconPercentage100.mjs.map
